export const mapProjectDetails = (omekaData: any) => {
  const projectId = omekaData?.['projects:projectIdentifier']?.map((item: any) => item?.['@value']);
  const projectUniqueCode = omekaData?.['projects:projectUniqueCode']?.map((item: any) => item?.['@value']);
  const projectTitle = omekaData?.['projects:projectTitle']?.map((item: any) => item?.['@value']);
  const projectEnTitle = omekaData?.['projects:projectEnTitle']?.map((item: any) => item?.['@value']);
  const alternativeTitle = omekaData?.['projects:projectAlternativeTitle']?.map((item: any) => item?.['@value']);
  const projectLanguage = omekaData?.['projects:projectLanguage']?.map((item: any) => item?.['@value']);
  const projectDuration = omekaData?.['projects:projectDuration']?.map((item: any) => item?.['@value']);
  const projectLicense = omekaData?.['projects:projectCreativeCommons']?.map((item: any) => item?.['@value']); 
  const projectKeywords = omekaData?.['projects:projectKeyword']?.map((item: any) => item?.['@value']);
  const projectEducational = omekaData?.['projects:projectEducational']?.map((item: any) => item?.['@value']); 
  const projectType = omekaData?.['projects:projectRelationWithTypeOfProject']?.map((item: any) => item?.['@value']);
  const projectLocationText = omekaData?.['projects:projectRelationWithLocation']?.map((item: any) => item?.['@value']);
  const projectLocationItem = omekaData?.['projects:projectRelationWithLocation']?.map((item: any) => item?.['display_title']);
  const arraysProjectLocation = [projectLocationItem, projectLocationText];
  const projectLocation = arraysProjectLocation.flat().filter(item => item !== undefined);
  const projectYear = omekaData?.['projects:projectYear']?.map((item: any) => item?.['@value']);
  const countryOrigin = omekaData?.['projects:projectCountry']?.map((item: any) => item?.['@value']);
  const projectCopyrights = omekaData?.['projects:projectCopyright']?.map((item: any) => item?.['@value']);
  const projectComments = omekaData?.['projects:projectComments']?.map((item: any) => item?.['@value']);
  const organization = omekaData?.['projects:projectOrganisation']?.map((item: any) => item?.['@value']);
  const trainer = omekaData?.['projects:projectTrainer']?.map((item: any) => item?.['@value']);
  const target = omekaData?.['projects:projectComments']?.map((item: any) => item?.['@value']);
  const creationTeam = omekaData?.['projects:projectCreationTeam']?.map((item: any) => item?.['@value']);
  const projectLab = omekaData?.['projects:projectLab']?.map((item: any) => item?.['@value']);
  const projectBelongsTo = omekaData?.['projects:projectBelongsTo']?.map((item: any) => item?.['@value']);
  const awards = omekaData?.['projects:projectAward']?.map((item: any) => item?.['@value']);
  const projectDescription = omekaData?.['projects:projectDescription']?.map((item: any) => item?.['@value']);
  const projectEnDescription = omekaData?.['projects:projectEnDescription']?.map((item: any) => item?.['@value']);
  const projectFormat = omekaData?.['projects:projectFormat']?.map((item: any) => item?.['@value']);
  const projectColor = omekaData?.['projects:projectColor']?.map((item: any) => item?.['@value']);
  const projectSound = omekaData?.['projects:projectSound']?.map((item: any) => item?.['@value']);
  const projectSize = omekaData?.['projects:projectSize']?.map((item: any) => item?.['@value']);
  const projectHeight = omekaData?.['projects:projectHeight']?.map((item: any) => item?.['@value']);
  const projectWidth = omekaData?.['projects:projectWidth']?.map((item: any) => item?.['@value']);
  const projectFrameRate = omekaData?.['projects:projectFrameRate']?.map((item: any) => item?.['@value']);
  const projectAspectRatio = omekaData?.['projects:projectAspectRatio']?.map((item: any) => item?.['@value']);
  const projectEnComments = omekaData?.['projects:projectEnComments']?.map((item: any) => item?.['@value']);
  const projectEduInstitution = omekaData?.['projects:projectEduInstitution']?.map((item: any) => item?.['@value']);
  const projectEduLevel = omekaData?.['projects:projectEduLevel']?.map((item: any) => item?.['@value']);
  const projectNumberPlayers = omekaData?.['projects:projectNumberPlayers']?.map((item: any) => item?.['@value']);
  const projectsMutualGoal = omekaData?.['projects:projectsMutualGoal']?.map((item: any) => item?.['@value']);
  const projectOtherLocations = omekaData?.['projects:projectOtherLocations']?.map((item: any) => item?.['@value']);
  
  return {
    projectId,
    projectUniqueCode,
    alternativeTitle,
    projectEnTitle,
    projectLanguage,
    projectDuration,
    projectLicense,
    projectKeywords,
    projectEducational,
    projectType,
    projectYear,
    countryOrigin,
    projectCopyrights,
    projectComments,
    organization,
    trainer,
    target,
    projectLab,
    projectBelongsTo,
    creationTeam,
    projectTitle,
    projectLocationText,
    projectLocationItem,
    projectLocation,
    awards,
    projectDescription,
    projectEnDescription,
    projectFormat,
    projectColor,
    projectSound,
    projectSize,
    projectHeight,
    projectWidth,
    projectFrameRate,
    projectAspectRatio,
    projectEnComments,
    projectEduInstitution,
    projectEduLevel,
    projectNumberPlayers,
    projectsMutualGoal,
    projectOtherLocations
  };
};

export const basicProjectDetails = [
  
  [ 
    'alternativeTitle', 
    'projectType', 
    'projectDescription', 
    'projectEnDescription',
    'projectBelongsTo',
    'projectYear', 
    'projectFormat',
    'projectDuration',
    'projectSound', 
    'projectColor', 
    'projectLocation'
  ],
  [
    'projectLanguage',
    'countryOrigin', 
    'projectSize', 
    'projectHeight', 
    'projectWidth', 
    'projectFrameRate',
    'projectAspectRatio',
    'projectCopyrights',
    'projectLicense',
    'projectComments',
    'projectEnComments',
    'projectKeywords',
    'projectOtherLocations'
  ]

];

export const educationalProjectDetails = [
  [
    'projectEducational',
    'projectEduInstitution',
    'projectEduLevel',
    'trainer',
    'projectLab' 
  ],
  [
    'creationTeam',
    'projectNumberPlayers',
    'projectsMutualGoal',
    'organization',
    'awards'
  ]
 
];